import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';

export const FILTER_QUERY_KEYS = {
    FACILITIES: 'facilities',
    STATUSES: 'statuses',
    VENDORS: 'vendors',
};

export const poNumberFilterConfig = {
    key: 'poNumber',
    label: 'PO Number',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter PO number...',
    },
};

export const statusFilterConfig = {
    key: 'statuses',
    label: 'Status',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: FILTER_QUERY_KEYS.STATUSES,
    },
    menuProps: {
        placeholder: 'Select statuses...',
        mergeWithStaticOptions: false,
    },
};

export const vendorFilterConfig = {
    key: 'vendorIds',
    label: 'Vendor',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: FILTER_QUERY_KEYS.VENDORS,
    },
    menuProps: {
        placeholder: 'Search vendors...',
        mergeWithStaticOptions: false,
    },
};

export const deliveryDateRangeFilterConfig = {
    key: 'deliveryDateRange',
    label: 'Scheduled Delivery Date',
    type: FilterType.DATE_RANGE,
    deletable: true,
};

export const facilityFilterConfig = {
    key: 'facilityIds',
    label: 'FC / Delivery Location',
    type: FilterType.SELECT,
    enableSearch: true,
    multi: true,
    options: [],
    deletable: true,
    remoteOptions: {
        queryId: FILTER_QUERY_KEYS.FACILITIES,
    },
    menuProps: {
        placeholder: 'Search facilities...',
        mergeWithStaticOptions: false,
    },
};

export const referenceNumberFilterConfig = {
    key: 'referenceNumber',
    label: 'Reference #',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter reference number...',
    },
};

export const PackagingPOFilterConfigArray = [
    poNumberFilterConfig,
    statusFilterConfig,
    vendorFilterConfig,
    deliveryDateRangeFilterConfig,
    facilityFilterConfig,
    referenceNumberFilterConfig,
];

export const PackagingPOSortConfig = {
    sortableFields: {
        id: { apiField: 'id' },
        createdAt: { apiField: 'created_at' },
    },
};

export const PackagingPOTransformConfig = {
    dateRangeKeys: {
        deliveryDateRange: { start: 'deliveryDateStart', end: 'deliveryDateEnd' },
    },
    numericArrayKeys: ['facilityIds', 'vendorIds'],
    stringArrayKeys: ['statuses'],
};
